<div class="container mt-4">
  <!-- <div class="row my-3">
      <div class="col">
          <div class="bg-white rounded-3 shadow">
              <ul class="nav align-items-center">
                  <li class="nav-item">
                      <a href="/" class="nav-link ">Home</a>
                  </li>
                  <li class="">/</li>
                  <li class="nav-item">
                      <div class="px-3">Contact CEO</div>
                  </li>
              </ul>
          </div>
      </div>
  </div>
  <div class="row">
    <div class="col-sm-8 mb-3">
        <div class="bg-white p-3 shadow">
        <h3>Contact CEO</h3>
        <p>National Rural Livelihoods Mission (NRLM)

          <p>NDCC-II, 7th Floor, Jai Singh Road</p>
          
          <p>New Delhi - 110001</p>
          
          <p>Phone: 011 23461708</p>
        </div>
    </div>
    <div class="col-sm-4 mb-3 position-relative">
        <app-footer-sub-menu></app-footer-sub-menu>
    </div>
</div> -->

<section class="contact-section">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <h2 class="fs-32 fw-600 text-primary" style="margin-bottom: 8px;">Contact Us</h2>
          <form [formGroup]="contactUsForm" (ngSubmit)="postContactUsInfo()">
            <div >
              <mat-form-field appearance="outline" class="example-full-width w-100 mb-0 pb-0">
                <mat-label>Name</mat-label>
                <input type="text" placeholder="Enter your full name" matInput formControlName="fullname" minlength="2" maxlength="20" (keypress)="alphabetsOnly($event)" required>
              </mat-form-field>
                <span class="home-invalid f-12" *ngIf="contactUsForm.controls['fullname'].value == '' && contactUsForm.controls['fullname'].touched">
                Name is Required *
                </span>
            </div>

            <div >
                <mat-form-field appearance="outline" class="example-full-width w-100 pb-0 ">
                <mat-label>Email</mat-label>
                <input type="email" placeholder="example@gmail.com" matInput formControlName="emaiID" required>
                </mat-form-field>
                <span class="home-invalid f-12" *ngIf="contactUsForm.controls['emaiID'].value == '' && contactUsForm.controls['emaiID'].touched" >
                Email is required *
                </span> 
                <span class="home-invalid f-12 " *ngIf="contactUsForm.controls['emaiID'].value != '' && contactUsForm.controls['emaiID'].touched && contactUsForm.controls['emaiID'].status == 'INVALID'">
                Please enter a valid Email ID !
                </span>
            </div>

            <div >
                <mat-form-field appearance="outline" class="example-full-width w-100 mb-0 pb-0" >
                <mat-label>Message</mat-label>
                <textarea matInput placeholder="Enter your message" formControlName="message" style="height: 15vh;" required></textarea>
                </mat-form-field>
                <span class="home-invalid f-12" *ngIf="contactUsForm.controls['message'].value == '' && contactUsForm.controls['message'].touched">
                Message is Required *
                </span>
            </div>
            <button class="btn btn-primary w-100 rounded-pill submit-btn my-2" [disabled]="contactUsForm.invalid" (click)="postContactUsInfo()">Submit</button>
          </form>
        </div>
      </div>
    </div>
  </section>
</div>